/* lystia-fab.js - Contact FAB (T-E2-17, parity/shell.md §6). Нативний ES-клас, без глобалів.
   Відкриття/закриття, scroll-lock (document.lystia.scrollLock), Esc у межах #fab, приховування під шторками
   (події lystia:overlay-open/close), D: приховування над футером (top < innerHeight - 40). */
(function () {
  'use strict';

  class LystiaFab {
    constructor(host) {
      this.host = host;
      this.main = host.querySelector('[data-fab-main]');
      this.scrim = host.querySelector('[data-fab-scrim]');
      this.opened = false;
      this.overlays = 0;
      this.main.addEventListener('click', () => (this.opened ? this.close() : this.open()));
      if (this.scrim) this.scrim.addEventListener('click', () => this.close());
      host.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
      window.addEventListener('scroll', () => this.checkFooter(), { passive: true });
      window.addEventListener('resize', () => this.checkFooter());
      document.addEventListener('lystia:overlay-open', () => { this.overlays++; this.syncOverlay(); });
      document.addEventListener('lystia:overlay-close', () => { this.overlays = Math.max(0, this.overlays - 1); this.syncOverlay(); });
      this.checkFooter();
    }

    open() {
      if (this.opened) return;
      this.opened = true;
      this.host.classList.add('is-open');
      this.main.setAttribute('aria-expanded', 'true');
      if (document.lystia) document.lystia.scrollLock.lock();
    }

    close() {
      if (!this.opened) return;
      this.opened = false;
      this.host.classList.remove('is-open');
      this.main.setAttribute('aria-expanded', 'false');
      if (document.lystia) document.lystia.scrollLock.unlock();
    }

    syncOverlay() {
      const hidden = this.overlays > 0;
      if (hidden) this.close();
      this.host.classList.toggle('is-hidden', hidden);
      this.checkFooter();
    }

    /* desktop: FAB не перекриває правий нижній кут футера */
    checkFooter() {
      const f = document.querySelector('footer');
      const over = !!f && window.innerWidth >= 1024 && f.getBoundingClientRect().top < window.innerHeight - 40;
      this.host.classList.toggle('is-over-ftr', over);
    }
  }

  const host = document.querySelector('[data-lystia-fab]');
  if (host) new LystiaFab(host);
})();
